import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "dashboard-area pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row g-lg-4 gy-5 mb-90" }
const _hoisted_4 = { class: "col-lg-9" }
const _hoisted_5 = { class: "dashboard-inner" }
const _hoisted_6 = { class: "author-area" }
const _hoisted_7 = { class: "author-img" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  src: "/assets/images/work-pages-logo.png",
  style: {"width":"90px","height":"auto !important"}
}
const _hoisted_10 = { class: "author-content" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Hello, I’m", -1)
const _hoisted_12 = { class: "counter-area" }
const _hoisted_13 = { class: "row g-lg-4 g-md-5 gy-5 justify-content-center" }
const _hoisted_14 = { class: "col-lg-4 col-sm-6" }
const _hoisted_15 = { class: "counter-single" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "counter-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/icon/tt-applied.svg",
    alt: "image"
  })
], -1)
const _hoisted_17 = { class: "coundown" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "Total Applied", -1)
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "odometer" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "+", -1)
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-4 col-sm-6\"><div class=\"counter-single two\"><div class=\"counter-icon\"><img src=\"/assets/images/icon/save-job.svg\" alt=\"image\"></div><div class=\"coundown\"><p>Saved Jobs</p><div class=\"d-flex align-items-center\"><h3 class=\"odometer\"> 0 </h3><span>+</span></div></div></div></div><div class=\"col-lg-4 col-sm-6\"><div class=\"counter-single four\"><div class=\"counter-icon\"><img src=\"/assets/images/icon/cv-review.svg\" alt=\"image\"></div><div class=\"coundown\"><p>Review CV</p><div class=\"d-flex align-items-center\"><h3 class=\"odometer\"> 0 </h3><span>+</span></div></div></div></div>", 2)
const _hoisted_24 = { class: "table-wrapper" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h5", { class: "title" }, "Current Applied Jobs:", -1)
const _hoisted_26 = { class: "table-wrapper2" }
const _hoisted_27 = { class: "eg-table table category-table mb-0" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Job Title"),
    /*#__PURE__*/_createElementVNode("th", null, "Apply Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Company"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1)
const _hoisted_29 = { "data-label": "Job Title" }
const _hoisted_30 = { class: "company-info" }
const _hoisted_31 = { class: "company-details" }
const _hoisted_32 = { class: "top" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/location.svg",
  alt: ""
}, null, -1)
const _hoisted_34 = { class: "d-flex flex-wrap" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/images/icon/arrow2.svg",
    width: "10",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "title ms-2" }, "Salary:")
], -1)
const _hoisted_36 = { style: {"width":"9rem !important"} }
const _hoisted_37 = { "data-label": "Apply Job" }
const _hoisted_38 = { "data-label": "Company" }
const _hoisted_39 = {
  class: "view-btn",
  href: "company-details.html",
  style: {"text-overflow":"initial"}
}
const _hoisted_40 = { "data-label": "Status" }
const _hoisted_41 = { class: "create-profile-btn" }
const _hoisted_42 = {
  href: "javascript:void(0)",
  class: "primry-btn-1 user-btn-custom"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_menu = _resolveComponent("user-menu")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_user_menu),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_ctx.user.photo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.user.photo,
                      style: {"width":"90px","height":"auto !important"}
                    }, null, 8, _hoisted_8))
                  : (_openBlock(), _createElementBlock("img", _hoisted_9))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("h4", null, _toDisplayString(_ctx.user.name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.jobApplications.length), 1),
                        _hoisted_21
                      ])
                    ])
                  ])
                ]),
                _hoisted_22
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("table", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobApplications, (application) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: application.id
                      }, [
                        _createElementVNode("td", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("h6", null, [
                                  _createVNode(_component_router_link, {
                                    to: _ctx.getJobDetail(application.job.job_key, application.job.job_slug)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(application.job.job_title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_33,
                                _createTextVNode(" " + _toDisplayString(application.job.location), 1)
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                _hoisted_35,
                                _createElementVNode("span", _hoisted_36, _toDisplayString(application.job.salary_range), 1)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_37, _toDisplayString(application.applied_on), 1),
                        _createElementVNode("td", _hoisted_38, [
                          _createElementVNode("a", _hoisted_39, _toDisplayString(application.job.company), 1)
                        ]),
                        _createElementVNode("td", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("a", _hoisted_42, _toDisplayString(application.status_name), 1)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}